import React from "react";
import styled from "styled-components";
import ServicesFold1 from "../components/ServicesPageComponents/ServicesFold1";
import ServicesWeWorkWith from "../components/ServicesPageComponents/ServicesWeWorkWith";
import OurProcess from "../components/ServicesPageComponents/OurProcess";
import Reviews from "../components/Reviews/Reviews";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { Helmet } from "react-helmet-async";

const ServicesPage = () => {
  return (
    <>
      <Helmet>
        <title>Custom Software Development Services | appssemble</title>
        <meta
          name="description"
          content="appssemble partners with scale-ups and SMEs to build fast, user-focused mobile and web apps. We offer UX/UI, AI, CarPlay apps, and more—tailored to your roadmap."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="appssemble" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Custom Software Development Services | appssemble"
        />
        <meta
          property="og:description"
          content="Discover how appssemble helps scale-ups and non-tech companies create mobile, web, and AI-powered solutions fast—aligned with their goals."
        />
        <meta property="og:url" content="https://appssemble.com/services" />
        <meta
          property="og:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Custom Software Development Services | appssemble"
        />
        <meta
          name="twitter:description"
          content="From UX/UI to AI and CarPlay apps, see how appssemble builds reliable, roadmap-aligned digital products for scale-ups and SMEs."
        />
        <meta
          name="twitter:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        <link rel="canonical" href="https://appssemble.com/services" />
      </Helmet>
      <Wrapper>
        <ServicesFold1 />
        <ServicesWeWorkWith />
        <OurProcess />
        <Reviews />
        <TrackingComponent />
      </Wrapper>
    </>
  );
};

export default ServicesPage;
const Wrapper = styled.div`
  min-height: 100vh;
`;
